import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/dados";

export const Route = createFileRoute("/_authenticated/dados")({
  head: () => ({
    meta: [
      { title: "Dados — Milky Moo Palmares" },
      {
        name: "description",
        content: "Área de metadados e cadastros auxiliares do controle de estoque.",
      },
      { property: "og:title", content: "Dados — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Área de metadados e cadastros auxiliares do controle de estoque.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
